import { clearVoiceCallSessionTracking } from '../../presentation/hooks/voice/application/voiceHangupCoordinator';

export const VOICE_SET_INCOMING_CALL = 'VOICE_SET_INCOMING_CALL';
export const VOICE_SET_ACTIVE_CALL = 'VOICE_SET_ACTIVE_CALL';
export const VOICE_CLEAR_INCOMING_CALL = 'VOICE_CLEAR_INCOMING_CALL';
export const VOICE_CLEAR_ACTIVE_CALL = 'VOICE_CLEAR_ACTIVE_CALL';
export const VOICE_SET_CURRENT_CALL_CONTROL_ID = 'VOICE_SET_CURRENT_CALL_CONTROL_ID';
export const VOICE_SET_CONNECTED = 'VOICE_SET_CONNECTED';
export const VOICE_SET_MUTED = 'VOICE_SET_MUTED';
export const VOICE_SET_RINGING = 'VOICE_SET_RINGING';
export const VOICE_SET_LOADING = 'VOICE_SET_LOADING';
export const VOICE_SET_ERROR = 'VOICE_SET_ERROR';
export const VOICE_RESET_CALL_STATE = 'VOICE_RESET_CALL_STATE';
export const VOICE_ADD_INCOMING_CALL = 'VOICE_ADD_INCOMING_CALL';
export const VOICE_REMOVE_INCOMING_CALL = 'VOICE_REMOVE_INCOMING_CALL';
export const VOICE_SET_SOCKET_CONNECTED = 'VOICE_SET_SOCKET_CONNECTED';
export const VOICE_SET_OUTBOUND_DIALING = 'VOICE_SET_OUTBOUND_DIALING';
export const VOICE_CLEAR_OUTBOUND_DIALING = 'VOICE_CLEAR_OUTBOUND_DIALING';
export const VOICE_RELEASE_CALL_SESSION = 'VOICE_RELEASE_CALL_SESSION';

/**
 * @param {import('../../presentation/hooks/voice/domain/voiceTypes').IncomingCallPayload} payload
 */
export const voiceSetIncomingCall = (payload) => ({
  type: VOICE_SET_INCOMING_CALL,
  payload
});

/**
 * @param {import('../../presentation/hooks/voice/domain/voiceTypes').VoiceCallParty} payload
 */
export const voiceSetActiveCall = (payload) => ({
  type: VOICE_SET_ACTIVE_CALL,
  payload
});

export const voiceClearIncomingCall = () => ({
  type: VOICE_CLEAR_INCOMING_CALL
});

export const voiceClearActiveCall = () => ({
  type: VOICE_CLEAR_ACTIVE_CALL
});

/**
 * @param {string|null} callControlId
 */
export const voiceSetCurrentCallControlId = (callControlId) => ({
  type: VOICE_SET_CURRENT_CALL_CONTROL_ID,
  payload: callControlId
});

/**
 * @param {boolean} isConnected
 */
export const voiceSetConnected = (isConnected) => ({
  type: VOICE_SET_CONNECTED,
  payload: isConnected
});

/**
 * @param {boolean} isMuted
 */
export const voiceSetMuted = (isMuted) => ({
  type: VOICE_SET_MUTED,
  payload: isMuted
});

/**
 * @param {boolean} isRinging
 */
export const voiceSetRinging = (isRinging) => ({
  type: VOICE_SET_RINGING,
  payload: isRinging
});

/**
 * @param {boolean} loading
 */
export const voiceSetLoading = (loading) => ({
  type: VOICE_SET_LOADING,
  payload: loading
});

/**
 * @param {string|null} error
 */
export const voiceSetError = (error) => ({
  type: VOICE_SET_ERROR,
  payload: error
});

export const voiceResetCallState = () => ({
  type: VOICE_RESET_CALL_STATE
});

/**
 * @param {import('../../presentation/hooks/voice/domain/voiceTypes').IncomingCallPayload} payload
 */
export const voiceAddIncomingCall = (payload) => ({
  type: VOICE_ADD_INCOMING_CALL,
  payload
});

/**
 * @param {string} callControlId
 */
export const voiceRemoveIncomingCall = (callControlId) => ({
  type: VOICE_REMOVE_INCOMING_CALL,
  payload: callControlId
});

/**
 * @param {boolean} isSocketConnected
 */
export const voiceSetSocketConnected = (isSocketConnected) => ({
  type: VOICE_SET_SOCKET_CONNECTED,
  payload: isSocketConnected
});

/**
 * Outbound PSTN leg dialing (UI stays in InitiateCall until call_answered socket).
 * @param {import('../../presentation/hooks/voice/domain/voiceTypes').IncomingCallPayload} payload
 */
export const voiceSetOutboundDialing = (payload) => ({
  type: VOICE_SET_OUTBOUND_DIALING,
  payload
});

export const voiceClearOutboundDialing = () => ({
  type: VOICE_CLEAR_OUTBOUND_DIALING
});

/**
 * Ends one call without dropping other ringing inbound legs.
 * @param {string} callControlId
 */
export const voiceReleaseCallSession = (callControlId) => {
  clearVoiceCallSessionTracking(callControlId);
  return {
    type: VOICE_RELEASE_CALL_SESSION,
    payload: callControlId
  };
};
